import React from "react";
import { Fade } from "react-awesome-reveal";
import { WiStars } from "react-icons/wi";

import { Helmet } from "react-helmet-async";

export default function JobHero() {
  return (
    <>
      {/* SEO  */}
      <Helmet>
        <title>
          Jobs | Custom Software, Website & App Development | Scode Software
          Solutions
        </title>
        <meta
          name="description"
          content="Transform your vision with innovative development solutions that
              craft seamless, user-driven experiences on web and mobile."
        />
        <link rel="canonical" href="https://www.scodesoft.com/solutions" />
      </Helmet>

      <section className="hero flex lg:items-center lg:justify-center lg:text-center">
        <div className="w-full sm:w-4/5 flex flex-col mb-5 sm:mb-0 sm:px-12 sm:-mt-2">
          <Fade direction="up" triggerOnce>
            <div className="flex lg:items-center lg:justify-center sm:justify-start mb-5">
              <h4 className="text-2xl text-theme-purple mr-2">Careers</h4>
              <WiStars size={35} className="text-theme-purple" />
            </div>
          </Fade>

          <Fade direction="up" triggerOnce>
            <h1 className="text-5xl text-theme-blue font-bold leading-tight mb-5 lg:text-center sm:text-left">
              Forge your future and shape tomorrow
            </h1>
          </Fade>

          <Fade direction="up" triggerOnce delay={50}>
            <p className="font-light text-xl text-gray-400 leading-relaxed lg:text-center sm:text-left">
              Transform your vision with innovative development solutions that
              craft seamless, user-driven experiences on web and mobile.
            </p>
          </Fade>
        </div>
      </section>
    </>
  );
}
